export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return

  const context = readPeerReturn()
  if (!context) return

  if (!peerEquals(peerFromPath(to.path), context.destination)) {
    clearPeerReturn()
  }
})
